import React from "react";
import CCTM_parse from "./CCTM_parse";
import { cloneElement } from 'react';
import BCMSDisabledPrompt from '../../components/BCMSDisabledPrompt/main.jsx';
export default class CCTM_transform {
  _map;
  _key;

  /**
   * Constructor for the CCTM_transform class
   * @param {ReactNode} cctmStructure - React children to transform
   * @param {Object} map - map mapping for transformation (optional)
   */
  constructor(cctmStructure, map) {
    // Default mapping for converting types to custom components
    const defaultmap = {
      nav: "CCTM_nav",
      route: "CCTM_route",
      link: "CCTM_link",
      item: "CCTM_item",
      subnav: "CCTM_subnav",
      items: "CCTM_items",
      demo: "CCTM_demo",
    };

    // Use provided map mapping or fallback to default
    this._map = map ?? defaultmap;
    this._cctmStructure = cctmStructure;
    this._key = 0;
  }

  /**
   * Static initializer for the class
   * @param {ReactNode} children - React children to transform
   * @param {Object} map - map mapping for transformation (optional)
   * @returns {CCTM_transform} - An instance of CCTM_transform
   */
  static init(children, map) {
    return new CCTM_transform(children, map);
  }
static deepCopyComponent(Component){
 
    const componentString = Component.toString();
    const newComponent = eval(`(${componentString})`);
    return newComponent;

}
  /**
   * Transforms React children into a structured object and renders components.
   * @param {ReactNode} children - React children to transform (optional)
   * @returns {Function} - A function to render components from the structure
   */
  transform(cctmStructure) {
    // Use provided children or the stored children
    cctmStructure = cctmStructure ?? this._cctmStructure;
    const _this = this;
    function newKey(node){
      const key = node.nodeName?node.nodeName+(_this._key++):"element"+(_this._key++)
      
      return key;;
    }
    // Reduce React children into a structured object
    const structure = React.Children.toArray(cctmStructure).reduce(
      (accumulator, child) => {
        if (React.isValidElement(child)) {
          // Add child to the structure with its type, props, children, and component
          accumulator[child.type.displayName] = {
            cctmType: child.type,
            props: child.props,
            children: child.props.children
              ? this.transform(child.props.children)
              : null,
            component: child.props.component,
            wrapper:child
          };
          return accumulator;
        }

        // Return original children for text nodes or invalid elements
        return children;
      },
      {} // Initialize as an empty object
    );
      
    // Return a function that renders components using the structured data
    const render = (result, child, children) => {
      // Find the corresponding structure for the child node name
     
     const selectedStructure = _this._map[child.nodeName]? structure[_this._map[child.nodeName]]:false;
 
     if(! structure[_this._map[child.nodeName]]){
         //throw a console the structure is missing a definition 
     
     }

      // Get the React component from the structure
      const Component = selectedStructure?.wrapper ?? <></>;
      let subElements = <></>; 
      const disableIf = (element, disable) => {
       const key = newKey(element);      
        return disable ? <BCMSDisabledPrompt key={key}>{element}</BCMSDisabledPrompt> : element;
    };
           if(children?.length){
            if(child.nodeName == "subnav"){
           
            }
            subElements =
        
            child.currentNode = child.currentNode??child;
          
              subElements =Object.values(child.currentNode.children).reduce(
                (accumulator, child) => {
                    const selectedChildStructure = _this._map[child.nodeName]? structure[_this._map[child.nodeName]]:false;
                    
                    const ChildComponent = selectedChildStructure?.wrapper ?? <></>;
                    // Add child to the structure with its type, props, children, and component
                    let ChildClone ={};
                    let disabled = CCTM_parse.getProps(child).disabled=="true";
                    if(child.nodeName =="subnav"){
                     
                        ChildClone = cloneElement(ChildComponent,{...child,children:child.children,key:newKey(child)});
                     
                      }else{
                        if(child.nodeName =="false"){
                          let children = Object.values(child.children).reduce((items,item)=>{
                            const selectedChildStructure = _this._map[item.nodeName]? structure[_this._map[item.nodeName]]:{};
                            const ChildComponent = selectedChildStructure?.wrapper ?? false;
                            items.push(cloneElement(ChildComponent,{...child,key:newKey(child)})) ;
                              return items;
                          },[])
                          
                          ChildClone = cloneElement(ChildComponent,{...child,children:children,key:newKey(child)});
                         }else{
                          ChildClone   = cloneElement(ChildComponent,{...CCTM_parse.getProps(child),key:newKey(child)});
                         }
                 
                 }

                    
                
                   accumulator.push( disableIf(ChildClone,disabled)) 
                  return   accumulator;
            
                  
                  
                },
               [] //
             
           )
        
            }
            else{
                  const selectedChildStructure = _this._map[child.nodeName]? structure[_this._map[child.nodeName]]:{};
                        const ChildComponent = selectedChildStructure?.wrapper ?? false;
             
                if(child.nodeName =="subnav"||child.nodeName =="items"){
                    subElements = cloneElement(ChildComponent,{...child,children:child.children,key:newKey(child)});
            
                  }else{
              
                subElements =cloneElement(ChildComponent,{...child,key:newKey(child)}) ;
             }

                      
                      
               
            }
         
      // Render the component with its attributes
      if (Component) {
        if(child.nodeName =="subnav"){
        
          result.push(cloneElement(Component,{...child,children:child.currentNode.children,key:newKey(child)}));
        }else{
           const Clone = cloneElement(Component,{...child,children:subElements,key:newKey(child)});
      
           result.push(Clone);
        }
      
      }

      return result;
    };
    return render;
  }
}